'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

RedirectionService=function(_BaseService){_inherits(RedirectionService,_BaseService);
function RedirectionService($state,$rootScope){_classCallCheck(this,RedirectionService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this._$state=$state;
_this._$rootScope=$rootScope;

_this._helpCenterRedirectIsPending=!1;

$rootScope.$on('$stateChangeSuccess',function(event,toState,toParams,fromState,fromParams){
_this._helpCenterRedirectIsPending=
toState.name==='fdc.features.login'&&
_.exists(toParams.return_to)&&
toParams.return_to.includes('/zendesk/login');
});return _this;
}_createClass(RedirectionService,[{key:'helpCenterRedirectIsPending',get:function()

{
return this._helpCenterRedirectIsPending;
}}]);return RedirectionService}(BaseService);


module.exports=RedirectionService;
//# sourceMappingURL=redirectionService.js.map
